module.exports = __webpack_public_path__ + "static/media/gist-zoom-auth-confirm-main.823e7b5a.png";